import { MediaTarget } from 'Shared/FrameModules/MediaLibrary/target';
import { FrameModules } from 'Shared/frame_modules';

FrameModules.add('WikiImageFrameModule', () => {
   when($('wikiSummaryImage'), elementId => {
      let targetElement = $(elementId);
      if (!targetElement) {
         return;
      }

      // MediaTarget.createFromElement fires a 'browse' event that
      // MediaManager.browse() handles — routing to Media Manager v2 when the
      // flag is on. The chosen item comes back as a legacy MediaItem, so the
      // display and hidden form field (wikiSummaryImageid) work unchanged.
      MediaTarget.createFromElement(targetElement);
   });
});
